import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageIntro"] */ "/opt/build/repo/src/app/components/PageIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UxProject"] */ "/opt/build/repo/src/app/components/UX/UxProject.tsx");
